import HomepagePromoTracking from '../core/HomepagePromoTracking';
import HeroDualImage from '../sections/HeroDualImage/index';
// import VIPSignup from '../sections/VIPSignup/index';
import CarouselLookBook from '../sections/CarouselLookBook/index';
import PodsAboveBelow from '../sections/PodsAboveBelow/index';
import VideoPlayerV2 from '../sections/VideoPlayerV2';

document.addEventListener('DOMContentLoaded', () => {
  HomepagePromoTracking();
  HeroDualImage();
  // VIPSignup();
  CarouselLookBook();
  PodsAboveBelow();
  VideoPlayerV2();
});
